<template>
<v-container fluid class="pa-0" :style="{'background':dark?'#1e1e1e':'white'}">
    <v-snackbar  v-model="errorLoading" color="error" :timeout="5000" top="top">
      {{errorMsg}}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="errorLoading=false"
        >
          close
        </v-btn>
      </template>
    </v-snackbar>
    <v-carousel :show-arrows="true" :cycle="autoplay" :interval="interval" hide-delimiters v-if="type === 'images'"  height="100vh">
      <v-carousel-item v-for="(item, i) in list" :key="i" class="center-img">
        <v-img :src="item.images" max-height="100%" position="center center" contain></v-img>
      </v-carousel-item>
    </v-carousel>
    <v-carousel :show-arrows="true" :cycle="autoplay" :interval="interval" hide-delimiters v-else-if="type === 'videos'"  height="100vh" v-model="itemIdx">
      <v-carousel-item v-for="(item, i) in list" :key="i" >
        <div v-if="itemIdx==i" v-html="item.title"></div>
        <div v-if="itemIdx==i" v-html="item.videos" class="postVideo"></div>
      </v-carousel-item>
    </v-carousel>
    <v-carousel :show-arrows="true" :cycle="autoplay" :interval="interval" hide-delimiters light height="100vh" v-else>
      <v-carousel-item v-for="(item, i) in list" :key="i"  :value="item">
        <div v-html="item.title"></div>
        <div v-html="item.content"></div>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import conf from "@/config/config";
import webmms from "webmms-client";
import { set as setCookie, get as getCookie } from "es-cookie";
import parse from "url-parse";

export default {
  props: ['pageParams'],
  data() {
    return {
      itemIdx:0,
      dark:false,
      autoplay:false,
      interval:6000,
      ddn: "K9kfuRSE",
      errorMsg: "",
      errorLoading: false,
      itemData: [],
      mms: webmms({wsurl:conf.wsurl,
        EiToken: getCookie("post-EiToken") || "",
        SToken: getCookie("post-SToken") || ""
      })
    };
  },
  computed: {
    list() {
      if(!this.itemData){
        this.errorMsg="No item is returned.";
        this.errorLoading=true;
      }
      return this.itemData || [];
    }
  },
  methods: {
    async updateItems() {
      const { tags, page, per_page, order, orderby, author, ddn } = this;
      this.removeEvent = this.mms.on("registered", async reply => {
        if(process.env.NODE_ENV!= 'production')
          console.log('reply=%s', JSON.stringify(reply))
        let {
          result: { DDN, EiToken, SToken }
        } = reply;
        setCookie("post-EiToken", EiToken);
        setCookie("post-SToken", SToken);

        let deviceInfo = {
          EiOwner: "",
          EiName: reply.result.EiName
              ? reply.result.EiName
              : "pgPOST" + this.makeId(5),
          EiType: ".page",
          EiTag: "",
          EiLog: ""
        };

        // let result = await mms.setDeviceInfo(deviceInfo);
        await this.mms.setDeviceInfo(deviceInfo);
        await this.track(this.mms, 'post', this.pageParams);
        let result = await this.mms.callMMS({
          topic: "blog://mms",
          DDN: ">h2/mustme/blog-mms-app",
          func: "getPosts",
          payload: {
            tags,
            page,
            per_page,
            order,
            orderby,
            author
          }
        });
        console.log(result);
        result= result[0].Reply;
        result = !result ? [] : result;
        if (this.type === "images") {
          let images = result.map(item => {
            const { title, content } = item;
            let images = content.rendered;
            let doc = new DOMParser().parseFromString(images, "text/html");
            images = doc.querySelector("img");
            if (images != null) {
              images = images.src;
            }
            return {
              images: images
            };
          });

          this.itemData = images.filter(item => item.images);
          console.log(this.itemData);
        } else if (this.type === "videos") {
          let videos = result.map(item => {
            const { title, content } = item;
            let videos = content.rendered;
            let doc = new DOMParser().parseFromString(videos, "text/html");

            videos = doc.querySelector("iframe");
            if (videos != null) {
              videos = videos.src;
              var newItem={};
              newItem.id=videos.split(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)|(playlist\?))(([&?]?list=([^#&?]+))|(\??v?=?([^#&?]*))).*/g);
              console.log(newItem.id);
              if(newItem.id[7]){ //is playlist
                newItem.id=newItem.id[10];
                newItem.isPlaylist=true;
              }else {
                newItem.id=newItem.id[12];
                newItem.isPlaylist=false;
              }
            }

            return {
              videos: videos!=null?newItem:videos
            };
          });

          this.itemData = videos.filter(item => item.videos);
          console.log( this.itemData);
          this.itemData = this.itemData.map(item => {

            let str =
              `<iframe
                  height="100%"
                  width="100%"
                  src="https://www.youtube.com/embed/${item.videos.isPlaylist?'videosseries?list=':''}${item.videos.isPlaylist?item.videos.id:item.videos.id+'?playlist='+item.videos.id}"
                  frameborder="0"
                  allowfullscreen
                  allow="clipboard-write;autoplay;accelerometer; encrypted-media; gyroscope; picture-in-picture">
                </iframe>`
            return {
              videos: str
            };
          });
        } else {
          this.itemData = result.map(item => {
            const { title, content } = item;
            return {
              title: title.rendered,
              content: content.rendered
            };
          });
        }
      });
    }
  },

  async created() {
    //const { query } = parse(window.location.href, true);
    const {
      ddn,
      tags = [],
      type,
      page = 1,
      per_page = 10,
      order = "desc",
      orderby = "date",
      author,
      dark,autoplay,interval
    } = this.pageParams;
    if(dark!=undefined)this.dark=dark;
    if(autoplay!=undefined)this.autoplay=autoplay=='1'?true:false;
    if(interval!=undefined)this.interval=interval;

    Object.assign(this, {
      ddn: ddn || this.ddn,
      tags: typeof tags === "string" ? [tags] : tags,
      type,
      page,
      per_page,
      order,
      orderby,
      author
    });
  },
  async beforeMount() {
    await this.updateItems();
  },
  beforeDestroy() {
    this.removeEvent();
  }
};
</script>

<style lang="scss">
.center-img{
    .v-responsive__content{
        display:flex;
        align-items: center;
    }
  }
.postImage img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.postVideo {
  height: 100%;
  width: 100%;
}
</style>
